import { createBrowserRouter, Navigate } from "react-router-dom";
import ProtectedRoute from "./ProtectedRoute";
import { Login } from "../pages/Login";
import { TermsConditions } from "../pages/TermsConditions";
import { PrivacyPolicy } from "../pages/PrivacyPolicy";
import Dashboard from "../pages/Dashboard";
import Orders from "../pages/Orders";
import Products from "../pages/Products";
import MainLayout from "../components/layout/MainLayout";
import { useUser } from "../providers/user";
import Franchises from "../pages/Franchises";
import Categories from "../pages/Categories"
import Banners from "../pages/Banners";
import Users from "../pages/Users";
import Zones from "../pages/Zones";
import DropoffLayout from "../components/dropoffLayout/DropoffLayout";
import Clients from "../pages/Clients";
import History from "../pages/History";
import Coupons from "../pages/Coupons";
import Notifications from "../pages/Notifications";
import Abandoned from "../pages/Abandoned";
import Tickets from "../pages/Tickets";
import Invoices from "../pages/Invoices";

const LoginRoute = () => {
  const { user } = useUser();
  return user ? <Navigate to="/" replace /> : <Login />;
};

const ConditionalLayout = () => {
  const { user } = useUser();

  if (user?.type === "dropoff" || user?.type === "operation") {
    return <DropoffLayout />;
  }

  return <MainLayout />;
};

// Update the router config
export const router = createBrowserRouter([
  {
    path: "/login",
    element: <LoginRoute />,
  },
  {
    path: "/terms-and-conditions",
    element: <TermsConditions />,
  },
  {
    path: "/privacy-policy",
    element: <PrivacyPolicy />,
  },
  {
    path: "/",
    element: <ProtectedRoute />,
    children: [
      {
        element: <ConditionalLayout />,
        children: [
          {
            index: true,
            element: <Navigate to="orders" replace />,
          },
          {
            path: "dashboard",
            element: <Dashboard />,
          },
          {
            path: "orders",
            element: <Orders />,
          },
          {
            path: "history",
            element: <History />,
          },
          {
            path: "products",
            element: <Products />,
          },
          {
            path: "franchise",
            element: <Franchises />,
          },
          {
            path: "categories",
            element: <Categories />,
          },
          {
            path: "banners",
            element: <Banners />,
          },
          {
            path: "users",
            element: <Users />,
          },
          {
            path: "zones",
            element: <Zones />,
          },
          {
            path: "clients",
            element: <Clients />,
          },
          {
            path: "coupons",
            element: <Coupons />,
          },
          {
            path: "notifications",
            element: <Notifications />,
          },
          {
            path: "abandoned-checkout",
            element: <Abandoned />,
          },
          {
            path: "invoices",
            element: <Invoices />,
          },
          {
            path: "tickets",
            element: <Tickets />,
          },
          {
            path: "*",
            element: <Navigate to="dashboard" replace />,
          },
        ],
      },
    ],
  },
]);
